import uly from "ulysses/core";
import "./controls/datetimepicker";
import "./controls/disable";
import "./controls/lookup";
import "./controls/password";
import "./controls/richtext";
import "./controls/searchbox";
import "./controls/utils";
import "./controls/validate";
import "./controls/wizard";
import "./controls/checkbox";
import "./controls/grid";
import "./controls/spinner";
import "./controls/timer";
import "./controls/grid_pager";
import "./controls/remote_search_model";
import "./controls/timeline";
import "./controls/datatable";
import "./controls/asyncview";
import "./controls/textiframe";
import "./controls/selection_checkbox";
import "./controls/users";
import "./controls/sidebar";
import "./controls/scroller";
import "./controls/signaturepad";
import "ulysses/controls/calculator";
import "ulysses/controls/currency";
import "ulysses/controls/model";
import "ulysses/controls/templating";
import "ulysses/controls/durationpicker";
import "ulysses/controls/media";
import "ulysses/controls/columnlist";
import "ulysses/controls/iconpicker";
import "ulysses/controls/masterdetail";
import "ulysses/controls/optionspicker";
import "ulysses/controls/priceselector";

export default uly;
